import { Component, effect, input, output, signal } from '@angular/core';
import { ErrorCategory } from 'src/app/models/error-category';
import { ErrorSearchFilter } from 'src/app/models/error-search-filter';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-basic-error-search-filter',
  templateUrl: './basic-error-search-filter.component.html',
  styleUrls: ['./basic-error-search-filter.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class BasicErrorSearchFilterComponent {

  categories = input<ErrorCategory[]>();
  errorSearchFilter = input<ErrorSearchFilter>();
  isSnapShot = input<boolean>(false);

  updateFilter = output<ErrorSearchFilter>();
  clearGridFilters = output<boolean>();

  localFilter = signal<ErrorSearchFilter>(null);
  origErrorSearchFilter: ErrorSearchFilter;

  constructor() {
    effect(() => {
      const filter = this.errorSearchFilter();
      if (filter != null && this.origErrorSearchFilter == null) {
        this.origErrorSearchFilter = Object.assign({}, filter);
        this.localFilter.set(Object.assign({}, filter));
      }
    });
  }

  updateFilters(): void {
    this.updateFilter.emit({...this.localFilter()});
  }

  clearFilters() {
    this.localFilter.set(Object.assign({}, this.origErrorSearchFilter));
    this.clearGridFilters.emit(true);
    this.updateFilters();
  }

  getLogPlaceholder(): string {
    let rc = 'Search...';
    if (this.isSnapShot()) {
      rc = 'Go To All Errors Tab For Log Message Database Search...';
    }
    return rc;
  }
}
